import { render, staticRenderFns } from "./DialogNotificationSettings.vue?vue&type=template&id=f6969e34&scoped=true&"
import script from "./DialogNotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./DialogNotificationSettings.vue?vue&type=script&lang=ts&"
import style0 from "./DialogNotificationSettings.vue?vue&type=style&index=0&id=f6969e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6969e34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
